import type { BundleItem } from "@p0security/shared/types/bundle";
import { useCallback } from "react";

import type { EditorEntry } from "./BundleMemberPicker";
import { IntegrationResourceGroup } from "./IntegrationResourceGroup";

export const GroupedSection: React.FC<{
  integrationKey: string;
  entries: EditorEntry[];
  onEntryChange: (key: string, item: BundleItem | undefined) => void;
  onEntryRemove: (key: string) => void;
  onAddEntry: (integrationKey: string) => void;
  duplicateWarnings: Map<string, string>;
  addDisabled: boolean;
  onAvailableIntegrations: (keys: string[]) => void;
}> = ({
  integrationKey,
  entries,
  onEntryChange,
  onEntryRemove,
  onAddEntry,
  duplicateWarnings,
  addDisabled,
  onAvailableIntegrations,
}) => {
  const handleAddEntry = useCallback(
    () => onAddEntry(integrationKey),
    [integrationKey, onAddEntry]
  );
  return (
    <IntegrationResourceGroup
      integrationKey={integrationKey}
      entries={entries}
      onEntryChange={onEntryChange}
      onEntryRemove={onEntryRemove}
      onAddEntry={handleAddEntry}
      duplicateWarnings={duplicateWarnings}
      addDisabled={addDisabled}
      onAvailableIntegrations={onAvailableIntegrations}
    />
  );
};
